"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.command = void 0;
const plugins_1 = require("../plugins");
const DEFAULTS = {};
function command(opts) {
    const vals = { ...DEFAULTS, ...opts };
    const result = new plugins_1.CommandColumn(opts);
    const commandFormatter = (row, cell, value, columnDef, data) => {
        return value;
    };
    commandFormatter.exportRawData = true;
    return commandFormatter;
}
exports.command = command;
//# sourceMappingURL=command.js.map